import { render } from "./index.vue?vue&type=template&id=dfd730f4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__